import { CHECK_IN_SETTINGS_PATH } from 'api/constants';
import { getOptions, getCheckInCredentials } from 'utils/api';

export const getSettingsApiConfig = (id, queryParams) => {
  const credentials = getCheckInCredentials(id, queryParams);
  const options = getOptions('GET', credentials);

  return {
    path: CHECK_IN_SETTINGS_PATH,
    options,
  };
};
